import angular from 'angular';

import BreadcrumbsComponent from './breadcrumbs.component';

const BreadcrumbsModule = angular
    .module('control-room.commons.basic.components.breadcrumbs', [])
    .component('crBreadcrumbs', BreadcrumbsComponent);

export default BreadcrumbsModule;
